import React from "react";

import logo from "../logo.png";
function Header() {
  return (
    <div className="customHeader">
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>
      <div className="title">
        <h2>Stajyer Değerlendirme Formu</h2>
      </div>
    </div>
  );
}

export default Header;
